<template>
  <article>
    <section class="xbed-sub-title">
      <span>订单基本信息</span>
    </section>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>订单管理</BreadcrumbItem>
        <BreadcrumbItem>订单详情</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <div style="width:1150px">
      <Card :bordered="false" style="width:1100px">
        <!-- <Spin fix v-if="orderSpinShow"></Spin> -->
        <Row style="marginBottom:10px">
          <Col span="4">订单号：</Col>
          <Col span="8">{{ order.orderNo }}</Col>
          <Col span="4">下单人：</Col>
          <Col span="8">{{ order.name }}</Col>
        </Row>
        <Row style="marginBottom:10px">
          <Col span="4">联系电话：</Col>
          <Col span="8">{{ order.phone }}</Col>
          <Col span="4">下单时间：</Col>
          <Col span="8">{{ order.createdAt }}</Col>
        </Row>
        <Row style="marginBottom:10px">
          <Col span="4">租房类型：</Col>
          <Col span="8">{{ ['', '短租', '长租', '钟点房'][order.rentType] }}</Col>
          <Col span="4">订单来源：</Col>
          <Col span="8">{{ order.orderSourceName }}</Col>
        </Row>
        <Row style="marginBottom:10px">
          <Col span="4">OTA单号：</Col>
          <Col span="8">{{ order.otherNo ? order.otherNo : "&nbsp;" }}</Col>
          <Col span="4">订单备注：</Col>
          <Col span="8">{{ order.remark }}</Col>
        </Row>
        <Row style="marginBottom:10px">
          <Col span="4">渠道费用：</Col>
          <Col span="8">￥{{ ((Number(order.otherChannelExpenses) +
            Number(order.channelCommission)) / 100).toFixed(2) }}</Col>
          <Col span="4">预计到店：</Col>
          <Col span="8">{{ checkins.arrivalTime }}</Col>
        </Row>
        <Row>
          <Col span="4">姓名备注：</Col>
          <Col span="8">{{ order.checkinerName }}</Col>
          <Col span="4">开票状态：</Col>
          <Col span="8">{{ order.invoiceStatus }}</Col>
        </Row>
      </Card>
      <Card class="card-default" :bordered="false" style="margin-top:10px;width:1100px">
        <!-- <Spin fix v-if="paySpinShow"></Spin> -->
        <Row style="marginBottom:10px">
          <Col span="4">订单原价：</Col>
          <Col span="8">￥{{ (pay.price / 100).toFixed(2) }}</Col>
        </Row>
        <Row style="marginBottom:10px">
          <Col span="4">优惠：</Col>
          <Col span="8">￥{{ (pay.discount / 100).toFixed(2) }}</Col>
        </Row>
        <Row style="marginBottom:10px">
          <Col span="4">订单应付：</Col>
          <Col span="8">
            <Tag color="error">￥{{ (pay.shouldPay / 100).toFixed(2) }}</Tag>
          </Col>
        </Row>
        <Row style="marginBottom:10px">
          <Col span="4">应付明细：</Col>
          <Col span="20">
            <Tag color="primary">房费：</Tag>￥{{ (pay.realRoomPrice / 100).toFixed(2) }} &nbsp;
            <Tag color="success">服务：</Tag>￥{{ (pay.serviceFee / 100).toFixed(2) }} &nbsp;
            <Tag color="warning">押金：</Tag>￥{{ (pay.bargainMoney / 100).toFixed(2) }}
          </Col>
        </Row>
        <Row style="marginBottom:10px">
          <Col span="4">订单实付：</Col>
          <Col
            span="8">￥{{ (pay.userRealPay / 100).toFixed(2) }}（含卡券抵现{{ (pay.totalCardRealPrice / 100).toFixed(2) }}元，含Xdollar抵现{{ (pay.xdollar / 100).toFixed(2) }}
            元）</Col>
        </Row>
        <Row style="marginBottom:10px">
          <Col span="4">发票金额：</Col>
          <Col span="8">￥{{ (order.invoicePrice / 100).toFixed(2) }}</Col>
        </Row>
        <Row style="marginBottom:10px">
          <Col span="4">支付状态：</Col>
          <Col span="8">
            <span>{{ ["待支付", "已支付", "待退款", "已取消"][pay.payStatus] }}</span>
            <tag v-if="pay.waitRefundPrice > 0" color="error">待退款</tag>
          </Col>
        </Row>
        <Row>
          <Col span="4">{{ pay.waitRefundPrice > 0 && !pay.waitPay > 0 ? '待退' : '等待支付' }}：</Col>
          <Col span="8">
            <Button type="success" v-if="pay.waitPay > 0" @click="payCheckin">￥{{ (pay.waitPay / 100).toFixed(2) }}
              代客支付</Button>
            <span v-if="(pay.waitRefundPrice >= 0 && pay.waitPay <= 0)"><Tag
                color="error">￥{{ (pay.waitRefundPrice / 100).toFixed(2) }}</Tag></span>
            <Button type="success" v-if="pay.waitPay > 0" style="margin-left:10px" @click="hotelPayBtn">酒店前台支付</Button>
          </Col>
        </Row>
      </Card>
    </div>
    <div style="margin-top:20px">
      <Tabs style="width:1100px" @on-click="toggleTab">
        <TabPane label="入住单" name="checkList">
          <component ref="checkList" :is="checkListName" :checkIds="pay.checkinIds" :checkinId="checkinId"
            :checkins="checkins" :checkinState="checkinState" :powers="powers" :lodgerInfo="lodgerInfo"
            :hotelList="hotelList" :roomType="roomType" :roomList="roomList" :dateInfo="dateInfo" :overStay="overstay"
            :order="order" :checkoutInfo="checkoutInfo" :unfinishConsumptions="unfinishConsumptions"
            @addCustomer="onAddCustomer" @delCustomer="onDelCustomer" @checkin="onCheckIn"
            @cancleChildOrder="onCancleChildOrder" @getLodgerInfo="queryLodgerInfo" @cancleOrder="onCancleOrder"
            @qureyRoomInfo="onQueryRoomInfo" @qureyRoomList="onQureyRoomList" @subChangeRoom="onSubChangeRoom" @alppyLateCheckOut="onAlppyLateCheckOut"
            @resetPwdEvent="onResetPwdEvent" @overStayCalculation="onOverStayCalculation" @overStaySub="onOverStaySub"
            @getCheckoutInfo="OnCheckoutInfo" @subCheckout="onSubCheckout" @validateChinkiner="onValidateChinkiner"
            @changeCheckinId="onChangeCheckinId" @queryDiffPrice="onQueryDiffPrice"
            @getUnfinishConsumptions="getUnfinishConsumptions">
          </component>
        </TabPane>
        <TabPane label="订单支付明细" name="payDetail">
          <component :is="payDetailName" :settlementResult="settlementResult"></component>
        </TabPane>
        <TabPane label="退款明细" name="refundDetail">
          <RefundDetail :refund="refund"></RefundDetail>
        </TabPane>
        <TabPane label="操作记录详情" name="operateDetail">
          <OperateDetail :orderTrail="orderTrail"></OperateDetail>
        </TabPane>
        <TabPane label="订单短信" name="orderMessage">
          <order-message :orderSms="orderSms"></order-message>
        </TabPane>
      </Tabs>
    </div>
    <Modal title="代客支付" v-model="payModal.display" :loading="true" @on-ok="payModalBtn" ref="payModal">
      <Form :label-width="90" label-position="left">
        <FormItem label="金额（¥）">
          <Input disabled v-model="payModal.data.price"></Input>
        </FormItem>
        <FormItem label="支付方式">
          <Select v-model="payModal.data.payType">
            <Option value="7">银联（线下）</Option>
            <Option value="8">支付宝（线下）</Option>
            <Option value="9">微信（线下）</Option>
            <Option value="10">现金（线下）</Option>
            <Option value="11">其他（线下）</Option>
          </Select>
        </FormItem>
        <FormItem label="备注">
          <Input type="textarea" v-model="payModal.data.remark"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal :title="hotelPay.title" v-model="hotelPay.display">
      <Row v-if="hotelPay.selectPayType">
        <Col span="8" offset="4">
          <Button type="primary" @click="payTypeBtn(1)">微信</Button>
        </Col>
        <Col span="8" offset="4">
          <Button type="primary" @click="payTypeBtn(2)">支付宝</Button>
        </Col>
      </Row>
      <Row v-if="!hotelPay.selectPayType">
        <p>扫描或输入条形码</p>
      </Row>
      <Row v-if="!hotelPay.selectPayType">
        <Input v-model="hotelPay.code"></Input>
      </Row><br>
      <Row v-if="!hotelPay.selectPayType">
        <Button type="primary" @click="changePayType">更换支付方式</Button>
      </Row>
      <div slot="footer">
        <Button v-if="!hotelPay.selectPayType" type="primary" @click="subHotelPay"
          :loading='subHotelPayLoading'>提交</Button>
        <Button @click="hotelPay.display = false">取消支付</Button>
      </div>
    </Modal>
  </article>
</template>  

<script>
/* eslint-disable */
import Moment from "moment";
import Utils from "@/utils";
//import Config from "../../config";
import API from "@/api";

import CheckList from './check-list.vue'
import PayDetail from './pay-detail'
import RefundDetail from './refund-detail'
import OperateDetail from './operate-detail'
import OrderMessage from './order-message'

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.orderNo = Utils.getUrlParameterByName("orderNo")
    this.checkinId = Number(Utils.getUrlParameterByName("checkinId"))
    this.headerENV = Utils.aliHeaderEnv(this.env)
    this.AuthorToken = Utils.findFromLocalStorage("Author-token");
    this.init();

    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': this.headerENV,
      'Authorization': this.AuthorToken,
      // 'group': 'dev' // 本地请求才需要加该参数
    }
    // if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'testing') {
    //   this.protHeaders.group = process.env.NODE_ENV === 'development' ? 'dev' : 'qa'
    // }
  },
  mounted() {
    this.$Notice.config({
      top: 200
    });
  },
  data() {
    return {
      hotelPay: {
        title: '选择支付方式',
        display: false,
        selectPayType: true,
        payType: '',
        code: ''
      },
      subHotelPayLoading: false,
      payModal: {
        display: false,
        data: {
          orderNo: "",
          remark: "",
          payType: "",
          price: ""
        }
      },
      checkListName: '',
      payDetailName: '',
      order: {},
      // orderSpinShow:false,
      checkins: {},
      pay: {},
      // paySpinShow:false,
      powers: {},
      settlementResult: {
        "data": [],
        "sum": 0
      },
      refund: {},
      orderTrail: [],
      orderSms: [],
      checkinState: false,
      hotelList: [],
      remainRoomPrice: 0,
      roomType: [],
      roomList: [],
      dateInfo: {},
      overstay: {},
      checkoutInfo: {},
      lodgerInfo: {},
      unfinishConsumptions: {}
    }
  },
  methods: {
    async subHotelPay() {
      if (!(/\d{16,24}/).test(this.hotelPay.code)) {
        this.$Notice.error({
          title: '请输入正确条形码'
        })
        return
      }
      this.subHotelPayLoading = true;
      let resp = (await API.omsAPI[this.env].order.payWithBarCode(
        this.hotelPay.code,
        this.username,
        this.orderNo,
        this.hotelPay.payType == 1 ? 'wechat' : 'alipay',
        this.token
      )).data
      this.subHotelPayLoading = false;
      if (resp.retCode) {
        this.$Notice.error({
          title: '操作失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
        title: '操作成功'
      })
      this.hotelPay.display = false;
      this.getOrder();
      this.payInfo()
    },
    changePayType() {
      this.hotelPay.title = "选择支付方式";
      this.hotelPay.selectPayType = true;
    },
    payTypeBtn(type) {
      this.hotelPay.payType = type;
      this.hotelPay.title = type == 1 ? '微信支付' : '支付宝支付';
      this.hotelPay.selectPayType = false;
    },
    hotelPayBtn() {
      this.hotelPay.title = '选择支付方式';
      this.hotelPay.display = true;
      this.hotelPay.code = '';
      this.hotelPay.selectPayType = true;
    },
    payCheckin() {
      if (!this.powers.payCheckin) {
        this.$Notice.error({
          title: '您没有权限操作此功能'
        })
        return
      }
      this.payModal.data = {
        orderNo: this.orderNo,
        remark: this.pay.remark,
        payType: this.pay.payType,
        price: (this.pay.waitPay / 100).toFixed(2)
      }
      this.payModal.display = true;
    },
    async payModalBtn() {
      this.$refs.payModal.buttonLoading = false;
      if (!this.payModal.data.payType) {
        this.$Notice.error({ title: '请选择支付方式' })
        return
      }
      if (!this.payModal.data.remark) {
        this.$Notice.error({ title: '请填写备注' })
        return
      }
      let resp = (await API.omsAPI[this.env].php.payCheckin({
        orderNo: this.payModal.data.orderNo,
        remark: this.payModal.data.remark,
        payType: this.payModal.data.payType,
        price: this.pay.waitPay
      })).data
      this.payModal.display = false;
      if (resp.retcode !== 0) {
        this.$Notice.error({
          title: '操作失败',
          desc: resp.retmsg
        })
        return
      }
      this.$Notice.success({
        title: '操作成功'
      })
      this.getOrder();
      this.payInfo()
    },
    async init() {
      this.queryOrderCountByXbedOrderNo();
      this.getOrder();
      this.getOrderTrail();
      this.payInfo();
      this.getPowers();
      this.getSettlement();
      this.getOrderSms();
      this.queryRefunds();
    },
    toggleTab(tabName) {
      if (tabName == 'orderMessage') {
        if (!Utils.hasPermission('api_sms_orderSmsRecordList')) {
          this.$Notice.error({
            title: "无权限操作"
          });
          this.orderSms = []
          return;
        }
        this.getOrderSms();
      }
    },
    async queryOrderCountByXbedOrderNo() {
      let resp = (await API.omsAPI[this.env].php.queryOrderCountByXbedOrderNo(
        { xbedOrderNo: this.orderNo }
      )).data;
      if (resp.retcode != 0) {
        this.$Notice.error({
          title: "查询失败",
          desc: resp.retmsg
        });
        return;
      }
    },
    async getOrder() {
      // this.orderSpinShow = true;
      let resp = (await API.omsAPI[this.env].php.getOrder(
        this.orderNo
      )).data;
      // this.orderSpinShow = false;
      if (resp.retcode != 0) {
        this.$Notice.error({
          title: "查询失败",
          desc: resp.retmsg
        });
        return;
      }
      this.order = resp.retdata;
    },
    async getOrderTrail() {
      let resp = (await API.omsAPI[this.env].php.getOrderTrail(
        this.orderNo
      )).data;
      if (resp.retCode != 21020000) {
        this.$Notice.error({
          title: "查询失败",
          desc: resp.retmsg
        });
        return;
      }
      this.orderTrail = resp.data;
    },
    async payInfo() {
      // this.paySpinShow = true;
      let resp = (await API.omsAPI[this.env].php.payInfo(
        this.orderNo
      )).data;
      // this.paySpinShow = false;
      if (resp.retcode != 0) {
        this.$Notice.error({
          title: "查询失败",
          desc: resp.msg
        });
        return;
      }
      this.pay = resp.retdata;
      (!this.checkinId) && (this.checkinId = resp.retdata.checkinIds[0].checkinId);
      await this.getCheckins();
      this.payDetailName = 'pay-detail'
    },
    async getPowers() {
      let resp = (await API.omsAPI[this.env].php.getOrderPower(
        105
      )).data;
      this.powers = resp;
    },
    async getSettlement() {
      let resp = (await API.omsAPI[this.env].php.getSettlement(
        this.orderNo
      )).data;
      if (resp.retcode != 0) {
        this.$Notice.error({
          title: "查询失败",
          desc: resp.retmsg
        });
        return;
      }
      this.settlementResult = resp.retdata;
    },
    async getOrderSms() {
      let params = {
        orderNo: this.orderNo,
        pageNum: 1,
        pageSize: 99999
      }
      const resp = (await API.omsAPI[this.env].clientServer.smsRecordList(params, { 'x-ca-stage': this.headerENV, 'Authorization': this.AuthorToken })).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: "查询失败",
          desc: resp.msg
        });
      }
      this.orderSms = resp.list;
    },
    onChangeCheckinId(checkinId) {
      this.checkinId = checkinId
      if (checkinId) {
        this.getCheckins();
      }
    },
    async getCheckins() {
      let resp = (await API.omsAPI[this.env].php.getcheckInfo(
        this.checkinId
      )).data;
      if (resp.retcode != 0) {
        this.$Notice.error({
          title: "查询失败",
          desc: resp.retmsg
        });
        return;
      }
      this.checkins = resp.retdata;
      this.checkinState = false;
      this.checkins.checkiner.forEach(item => {
        if (item.checkin == 1) {
          this.checkinState = true;
        }
      });
      this.checkListName = 'check-list'
    },
    async onAddCustomer(param) { // 添加入住人
      let resp = (await API.omsAPI[this.env].php.addCustomer(param)).data;
      if (resp.retcode != 0) {
        this.$Notice.error({
          title: "添加失败",
          desc: resp.retmsg
        });
        return;
      }
      this.$Notice.success({
        title: '添加成功'
      })
      this.getCheckins();
    },
    async onDelCustomer(param) { //删除入住人
      let resp = (await API.omsAPI[this.env].php.delCustomer({ id: param.cusId })).data;
      if (resp.retcode != 0) {
        this.$Notice.error({
          title: "删除失败",
          desc: resp.msg
        });
        return;
      }
      this.$Notice.success({
        title: "删除成功",
        desc: resp.msg
      });
      this.getCheckins();
    },
    async onCheckIn(param) { //办理入住
      // let param = {
      //   checkinId: checkinId,
      //   infoId: infoId
      // }
      let resp = (await API.omsAPI[this.env].php.checkin(param)).data;
      if (resp.retcode == 0) {
        this.$Notice.success({
          title: "操作成功",
          desc: resp.retmsg
        });
        // this.getCheckins();
        this.payInfo();
      } else {
        if (resp.retdata.data !== null) {
          let error;
          switch (resp.retdata.data.reason) {
            case 0:
              error = "未知异常，不可进入下一步";
              break;
            case 2:
              error = "未支付";
              break;
            case 3:
              error = "可办理入住时间未到";
              break;
            case 4:
              error = "房间清洁中";
              break;
            case 5:
              error = "房间入于入住状态";
              break;
            case 6:
              error = "入住单未审核";
              break;
            default:
              error = "未知异常！！！";
              break;
          }
          this.$Notice.error({
            title: error
          });
        } else {
          this.$Notice.error({
            title: '办理入住失败',
            desc: resp.retmsg
          });
        }
      }
    },
    async onCancleChildOrder(param) { // 取消子入住单
      let resp = (await API.omsAPI[this.env].php.cancleChildOrder({ infoId: param.infoId })).data;
      if (resp.retcode != 0) {
        this.$Notice.error({
          title: "取消失败",
          desc: resp.retmsg
        });
        return;
      }
      this.$Notice.success({
        title: "取消成功",
        desc: resp.retmsg
      });
      this.getOrder();
      this.payInfo();
      this.getCheckins();
    },
    async onCancleOrder(obj) { //取消入住单
      // let param = {
      //   remark: obj.remark,
      //   checkinId: obj.checkinId
      // }
      let resp = (await API.omsAPI[this.env].php.cancleOrder(obj)).data;
      if (resp.retcode != 0) {
        this.$Notice.error({
          title: "取消失败",
          desc: resp.retmsg
        });
        return;
      }
      this.$Notice.success({
        title: "取消成功",
        desc: resp.retmsg
      });
      this.getOrder();
      this.payInfo();
      this.getCheckins();
    },
    async onQueryRoomInfo() {
      console.info(this.checkRoomParam);
      this.onQueryHotelList();
      this.onQueryRoomType();
    },
    async onQueryHotelList() { //查询门店
      let checkin = this.checkins
      let beginDate = Moment(checkin.checkinTime).format('YYYY-MM-DD HH:mm:ss');
      if (beginDate <= Moment(Moment().format('YYYY-MM-DD') + ' 06:00:00').format('YYYY-MM-DD HH:mm:ss')) {
        if (Moment().format('HH') < 12) beginDate = Moment().add(-1, 'd').format('YYYY-MM-DD');
        else beginDate = Moment().format('YYYY-MM-DD');
      }

      if (Moment(beginDate).format('YYYY-MM-DD') == Moment(checkin.checkoutTime).format('YYYY-MM-DD')) {
        // 计算后如果开始日期和结束日期相等，开始日期要减一 2017-02-01  到  2017-02-01是找不到可换房的房间的，因为后端自动给开始日期加上14:00:00，给结束日期加上12:00:00
        beginDate = Moment(beginDate).add(-1, 'd').format('YYYY-MM-DD');
      }
      let param = {
        beginDate: Moment(beginDate).format('YYYY-MM-DD'),
        endDate: this.checkRoomParam.endDate,
        roomId: this.checkRoomParam.roomId,
        checkinId: this.checkinId
      }
      let resp = (await API.omsAPI[this.env].php.onQueryHotelList(param)).data;
      if (resp.retCode == 21020000) {
        this.hotelList = resp.data.chainList;
        this.remainRoomPrice = resp.data.surplus / 100;
        this.dateInfo = {
          beginDate: resp.data.beginDate,
          endDate: resp.data.endDate,
          surplus: (resp.data.surplus / 100).toFixed(2),
          surplusDiscount: (resp.data.surplusDiscount / 100).toFixed(2)
        }
      } else {
        this.$Notice.error({
          title: "查询失败",
        });
      }
    },
    async onQueryRoomType() { //查询房型
      let resp = (await API.omsAPI[this.env].php.onQueryRoomType({ operTypeList: ['roomType'] })).data;
      this.roomType = resp.retdata;
    },
    async onQureyRoomList(obj) { //查询房间列表
      let param = Object.assign({}, this.checkRoomParam, obj);
      param.beginDate = this.dateInfo.beginDate;
      param.endDate = this.dateInfo.endDate;
      let resp = (await API.omsAPI[this.env].php.onQureyRoomList(param)).data;
      if (resp.retcode == 1) {
        const roomList = resp.retdata || []
        this.roomList = roomList.filter((item) => {
          return (item.roomId != param.roomId)
        })
      }
    },
    async onQueryDiffPrice(roomId) {
      let resp = (await API.omsAPI[this.env].php.queryDiffPrice({
        beginDate: this.dateInfo.beginDate,
        endDate: this.dateInfo.endDate,
        roomId: roomId,
        checkinId: this.checkinId
      })).data
      console.info(resp)
    },
    async onOverStayCalculation(endDate) { //续住
      let param = {
        "checkinId": this.checkinId,
        "endDate": endDate,
        "userId": this.order.userId,
        "rentType": this.order.rentType
      }
      // let discount;
      // if(param.rentType==2){
      //   discount = (await API.omsAPI[this.env].php.queryOverstayDiscount(param)).data/100;
      // }
      // console.info(discount);
      let resp = (await API.omsAPI[this.env].php.overStayCalculation(param)).data;
      if (resp.retcode != 0) {
        this.$Notice.error({
          title: '续住失败',
          desc: resp.retmsg
        })
        return;
      }
      this.overstay = resp.retdata;
    },
    async onOverStaySub(param) {  //提交续住单 overstayCheckin
      param.userId = this.order.userId;
      let resp = (await API.omsAPI[this.env].php.overstayCheckin(param)).data;
      if (resp.retcode == 0) {
        this.$Notice.success({
          title: '续住成功'
        });
        this.init();
      } else {
        this.$Notice.error({
          title: '续住失败',
          desc: resp.retmsg
        })
      }
    },
    async onSubChangeRoom(obj) {
      let param = {
        needPayBalance: obj.needPayBalance,
        checkinId: obj.checkinId,
        roomId: obj.roomId,
        remark: obj.remark
      }
      let resp = (await API.omsAPI[this.env].php.changeRoomId(param)).data;
      if (resp.retcode != 0) {
        this.$Notice.error({
          title: '换房失败',
          desc: resp.retmsg
        });
        return;
      }
      this.$Notice.success({
        title: '换房成功',
        desc: '5秒后刷新页面'
      });
      this.roomList = [];
      setTimeout(() => {
        this.init();
        this.checkinId = resp.retdata.checkin.checkinId;
      }, 5000)
    },
    async OnCheckoutInfo(checkinId) {
      let resp = (await API.omsAPI[this.env].php.getCheckOutMoney({
        checkinId
      })).data;
      if (resp.retCode != 21020000) {
        this.$Notice.error({
          title: '获取退房信息失败，请重试',
          desc: resp.msg
        })
        return
      }
      this.checkoutInfo = resp.data
    },
    async onSubCheckout(param) {
      let resp = (await API.omsAPI[this.env].php.subCheckoutInfo(param)).data
      if (resp.retcode == 0) {
        this.$Notice.success({
          title: '退房成功'
        })
        this.init();
      } else {
        this.$Notice.error({
          title: '退房失败',
          desc: resp.retmsg
        })
      }
    },
    async queryLodgerInfo(param) {
      let resp = (await API.omsAPI[this.env].php.queryLodgerInfo(param)).data
      if (resp.retcode != 1) {
        this.$Notice.error({
          title: '查询失败',
          desc: resp.retmsg
        })
      } else {
        this.lodgerInfo = resp.retdata;
      }
    },
    async onAlppyLateCheckOut(params) {
      const param = {
              checkinId: this.checkinId,
              phone: params.phone,
              operator: this.username,
              delayCheckoutTime: this.checkins.infos[0].delayCheckoutTime,
              remark: params.remark,
              source: "oms"
          }
          let resp = (await API.omsAPI[this.env].clientServer.applyLateCheckOut(param, { 'x-ca-stage': this.headerENV,  'Authorization': this.AuthorToken })).data;
          if(resp && typeof resp === 'boolean'){
            this.$Notice.success({
              title: '延迟退房申请成功',
              desc: '5秒后刷新页面'
            });
            setTimeout(() => {
              this.init();
              this.checkinId = resp.retdata.checkin.checkinId;
            }, 5000)
          } else {
            this.$Notice.error({
                title: resp.msg
             })
          }
    },
    async onResetPwdEvent(param) {
      param.checkinId = this.checkinId;
      let resp = (await API.omsAPI[this.env].php.resetPwd(param)).data
      this.$refs.checkList.resetPsd = false
      if (resp.retcode != 0 || resp.retdata.isSuccess == false) {
        this.$Notice.error({
          title: '门锁异常，重置密码失败！'
        })
        return
      }
      this.$Notice.success({
        title: '重置成功'
      })
    },
    async onValidateChinkiner() {
      let resp = (await API.omsAPI[this.env].php.validateCheckiner(
        { checkinId: this.checkinId }
      )).data;
      if (resp.retcode != 0) {
        this.$Notice.error({
          title: '验证失败',
          desc: resp.retmsg
        })
        return
      }
      this.$Notice.success({
        title: '验证成功'
      })
      this.getCheckins();
    },
    async queryRefunds() {
      let resp = (await API.omsAPI[this.env].php.queryRefunds(this.orderNo)).data
      if (resp.retcode != 0) {
        this.$Notice.error({
          title: '获取退款明细失败',
          desc: resp.msg
        })
        return
      }
      this.refund = resp.retdata
    },
    async getUnfinishConsumptions(param) { // 获取有效的账务
      const resp = (await API.omsAPI[this.env].clientServer.getCheckoutConsumptions({
        checkinId: this.checkinId,
        page: param.page,
        size: param.pageSize
      }, this.protHeaders)).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: resp.msg,
          desc: '获取有效的账务列表数据异常'
        })
        return
      }
      this.unfinishConsumptions = resp;
    }
  },
  computed: {
    checkRoomParam: function () {
      let defDate = {
        start: '',
        end: this.checkins.checkoutTime
      }
      let beginDate = Moment(this.checkins.checkinTime).format('YYYY-MM-DD HH:mm:ss');
      if (beginDate <= Moment(Moment().format('YYYY-MM-DD') + ' 06:00:00').format('YYYY-MM-DD HH:mm:ss')) {
        if (Moment().format('HH') < 12) {
          beginDate = Moment().add(-1, 'd').format('YYYY-MM-DD')
        } else {
          beginDate = Moment().format('YYYY-MM-DD');
        }
      }
      if (Moment(beginDate).format('YYYY-MM-DD') == Moment(this.checkins.checkoutTime).format('YYYY-MM-DD')) {
        // 计算后如果开始日期和结束日期相等，开始日期要减一 2017-02-01  到  2017-02-01是找不到可换房的房间的，因为后端自动给开始日期加上14:00:00，给结束日期加上12:00:00
        beginDate = Moment(beginDate).add(-1, 'd').format('YYYY-MM-DD');
      }
      defDate.start = beginDate;
      return {
        beginDate: defDate.start,
        endDate: defDate.end,
        rentType: this.checkins.rentType == '1' ? 'cnameWay=租赁方式/短租' : this.checkins.rentType == '2' ? 'cnameWay=租赁方式/长租' : 'cnameWay=租赁方式/钟点房',
        roomId: this.checkins.roomId,
        chainId: null,
        roomTypeName: null,
        custRoomNo: null,
        custRoomName: null,
      };
    }
  },
  components: {
    'check-list': CheckList,
    'pay-detail': PayDetail,
    RefundDetail,
    OperateDetail,
    "order-message": OrderMessage,
  }
}
</script>

<style lang="scss" scoped>.card-default {
  background-color: rgb(218, 237, 247)
}</style>




// WEBPACK FOOTER //
// src/pages/order/order_detail/order-detail.vue